
angular.module('procommTalentSearch').factory('procommFavoriteService', function (procommService, $http, ngDialog) {
  var service = {};

  service.state = { list: {} };

  service.loadFavorites = function () {
    $http.get('/wp-json/procomm/v1/get_favorites/' + wp_current_user_id + '?time=' + Math.random(),
      {
        headers: {
          'X-WP-Nonce': service.nonce
        }
      }
    ).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        console.log('load favorites', response);
        service.state.list = response.data.favorites;
      },
      function errorCallback (response) {
        console.log('fav error', response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      }
    );
  };

  service.toggleFavorite = function (demoID) {
    var cacheBuster = Math.random();
    if (!service.state.wp_current_user_id) {
      ngDialog.open({
        template: '/wp-content/themes/sage-8.5.1/angular-templates/login.html',
        controller: 'ProcommPlaylistController',
        className: 'ngdialog-theme-default'
      });

      return;
    }
    if (typeof service.state.list[demoID] === typeof undefined) {
      service.state.list[demoID] = true;
      $http.get('/wp-json/procomm/v1/add_favorite/demo/' + demoID + '/' + wp_current_user_id + '?time=' + cacheBuster,
        {
          headers: {
            'X-WP-Nonce': service.nonce,
            'Cache-Control': 'no-cache'
          }
        }
      ).then(
        function successCallback (response) {
          // this callback will be called asynchronously
          // when the response is available
          console.log('date', response);
          service.state.list = response.data.favorites;
        },
        function errorCallback (response) {
          console.log('fav error', response);
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        }
      );
    } else {
      delete service.state.list[demoID];

      $http.get('/wp-json/procomm/v1/remove_favorite/demo/' + demoID + '/' + wp_current_user_id + '?time=' + cacheBuster,
        {
          headers: {
            'X-WP-Nonce': service.nonce,
            'Cache-Control': 'no-cache'
          }
        }
      ).then(
        function successCallback (response) {
          // this callback will be called asynchronously
          // when the response is available
          console.log('date', response);
          service.state.list = response.data.favorites;
        },
        function errorCallback (response) {
          console.log('fav error', response);
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        }
      );
    }
  };

  service.isFavorite = function (demoID) {
    return (service.state.list[demoID] === true);
  };

  return service;
});

angular.module('procommTalentSearch').factory('procommPlaylistService', function (procommService, ngDialog, $http) {
  var service = {};

  service.state = { playlist: false, demo: false, talent: false, playlists: false, activePlaylist: false };

  service.http_config = {
    headers: {
      'X-WP-Nonce': service.nonce
    }
  };

  service.isDemoInPlaylist = function (demo, playlist) {
  	// console.log('checking', demo, playlist);
  	if (!playlist || !demo) {
  		return false;
  	}

  	for (index in playlist.demos) {
  		p_demo = playlist.demos[index];
  		if (p_demo.ID == demo.ID) {
  			return true;
  		}
  	}
  	// if()
  	return false;
  };

  service.createPlaylist = function (playlist) {
    $http.post('/wp-json/procomm/v1/playlist', playlist, {
      headers: {
        'X-WP-Nonce': service.nonce
      }
    }).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        console.log('playlist create', response);
        // console.log(service.state.playlists);
        service.state.playlists = response.data.playlists;
        service.state.activePlaylist = '' + response.data.insert_id;
        service.state.newPlaylist.title = '';
        // console.log(service.state.playlists);
        service.state.createNewMode = false;

        // service.state.playlists = response.data.playlists;
      },
      function errorCallback (response) {
        console.log('playlist create error', response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      }
    );
  };

  service.getPlaylistByID = function (id) {
  	for (index in service.state.playlists) {
      var test_playlist = service.state.playlists[index];
      if (test_playlist.ID == id) {
        return test_playlist;
      }
    }
  };

  service.removeItemFromPlaylist = function (demo, playlist) {
    return $http.post('/wp-json/procomm/v1/playlist/removeItem/', { demo: demo, playlist: playlist }, {
      headers: {
        'X-WP-Nonce': service.nonce
      }
    }).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        console.log('playlist remove', response);
        // console.log(service.state.playlists);
        // service.state.playlists = response.data.playlists;
        // service.state.newPlaylist.title = "";
        // // console.log(service.state.playlists);
        // service.state.createNewMode = false;

        // service.state.playlists = response.data.playlists;
        service.state.playlists = response.data.playlists;

        return Promise.resolve();
      },
      function errorCallback (response) {
	        console.log('playlist remove error', response);
        return Promise.reject();
      }
    );
  };

  service.addItemToPlaylist = function (demo, playlist) {
  	return $http.post('/wp-json/procomm/v1/playlist/addItem/', { demo: demo, playlist: playlist }, {
      headers: {
        'X-WP-Nonce': service.nonce
      }
    }).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        console.log('playlist add', response);
        // console.log(service.state.playlists);
        // service.state.playlists = response.data.playlists;
        // service.state.newPlaylist.title = "";
        // // console.log(service.state.playlists);
        // service.state.createNewMode = false;

        // service.state.playlists = response.data.playlists;
        service.state.playlists = response.data.playlists;

        return Promise.resolve();
      },
      function errorCallback (response) {
	        console.log('playlist add error', response);
        return Promise.reject();
      }
    );
  };

  service.loadPlaylists = function () {
    var cacheBuster = Math.random();

    $http.get('/wp-json/procomm/v1/playlist?time=' + cacheBuster, {
      headers: {
        'X-WP-Nonce': service.nonce
      }
    }).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        // console.log('playlist', response.data.playlists);
        service.state.playlists = response.data.playlists;
      },
      function errorCallback (response) {
        console.log('load playlist error', response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      }
    );
  };

  service.showDialog = function (talent, demo) {
    service.state.demo = demo;
    service.state.talent = talent;
    this.loadPlaylists();

    ngDialog.open({
      template: '/wp-content/themes/sage-8.5.1/angular-templates/playlist.html',
      controller: 'ProcommPlaylistController',
      className: 'ngdialog-theme-default'
    });
  };

  // service.loadPlaylists();

  return service;
});

angular.module('procommTalentSearch').factory('pcShareService', function (procommService, ngDialog, $http) {
  var service = {};

  service.state = { demo: false, talent: false, from_email: '', to_email: '', message: '' };
  service.dialog = false;
  service.showShareDialog = function (talent, demo) {
    service.state.demo = demo;
    service.state.talent = talent;
    service.state.playlist_slug = false;

    service.dialog = ngDialog.open({
      template: '/wp-content/themes/sage-8.5.1/angular-templates/share.html',
      controller: 'ProcommShareController',
      className: 'ngdialog-theme-default'
    });

    // service.dialog.closePromise.then(function (data) {
    //       console.log(data.id + ' has been dismissed.');
    //                 swal("Email sent!");

    //     });
  };

  service.showShareDialogPlaylist = function (playlist_slug) {
    service.state.playlist_slug = playlist_slug;
    service.state.demo = false;
    service.state.talent = false;

    service.dialog = ngDialog.open({
      template: '/wp-content/themes/sage-8.5.1/angular-templates/share.html',
      controller: 'ProcommShareController',
      className: 'ngdialog-theme-default'
    });

    // service.dialog.closePromise.then(function (data) {
    //       console.log(data.id + ' has been dismissed.');
    //                 swal("Email sent!");

    //     });
  };

  service.sendShareEmail = function () {
    service.dialog.close();

    if (wp_current_user_id) {
      service.state.user_id = wp_current_user_id;
    }

    // console.log('send share', service.state);

    $http.post('/wp-json/procomm/v1/share/email', service.state).then(
      function successCallback (response) {
        // this callback will be called asynchronously
        // when the response is available
        console.log('email share', response);

        var popup_message = 'All set - we shared your demo.';
        if (service.state.playlist_slug) {
          popup_message = 'All set - we shared your playlist.';
        }

        swal({
          title: 'Email Sent!',
          text: popup_message,
          timer: 2000,
          type: 'success'
        });

        // service.dialog.close();

        // service.state.list = response.data.favorites;
      },
      function errorCallback (response) {
        console.log('email share error error', response);

        swal({
          title: 'Email Error!',
          text: 'Something went wrong sending your email - please try again.',
          type: 'error'
        });
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      }
    );
  };
  return service;
});

angular.module('procommTalentSearch').factory('procommService', function () {
  var service = {};

  service.search_results = [];

  service.isPlayingState = { status: false, search: {}, demo: {} };

  var default_language_text = 'English American';

  if (default_language_post) {
    default_language_text = default_language_post.post_title;
  }

  service.searchState = { age_range: '', style: '', party: '', gender: '', language: default_language_text, search_text: '', favorites: false };

  service.defaultSearchState = { age_range: '', style: '', party: '', gender: '', language: default_language_text, search_text: '', favorites: false };

  service.downloadDemo = function (talent, demo) {
    window.open('/wp-json/procomm/v1/download_demo/' + demo.ID, '_blank');
  };

  service.getSearchResults = function($filter){
    var talentSearchController = testscope;
    var searchState = service.searchState;

    var results = talentSearchController.talentList;
    results = results.filter(talentSearchController.criteriaMatch(false))

    results.sort(function (a, b) {
      if(searchState.favorites || (! searchState.style && ! searchState.party) ){
        return a.primary_demo.sort_overall > b.primary_demo.sort_overall ? +1 : -1;
      }

      const a_demo = talentSearchController.scope.getFirstDisplayedDemo(a);
      const b_demo = talentSearchController.scope.getFirstDisplayedDemo(b);
      
          // console.log(a_demo, b_demo);

      if(searchState.party){
        if(a_demo.party != b_demo.party){
          if(a_demo.party.toLowerCase() == searchState.party){
            return -1;
          }
          else if(b_demo.party.toLowerCase() == searchState.party){
            return +1;
          }
        }
      }

      return a_demo.sort > b_demo.sort ? +1 : -1;;
    });

    results = results.slice(0, talentSearchController.itemLimit+1);

    return results;
  }

  service.getBookTalentURL = function (talent) {
    if (talent && typeof talent.ID !== typeof undefined) {
      return '/get-started?active_talent=' + talent.ID;
    }
    return '';
  };

  return service;
});
